import React from 'react'
import RangeDatePickerAndActionsLayout from '../../../components/Layouts/range-date-picker-and-actions-layout'
import { ActionButtonEnum } from '../../../enums/actionButtonEnum'
import { getBingoPerformanceReport } from '../../../services/reports'
import { DateFormatEnum } from '../../../enums/dateFormatEnum'
import {useAuth} from "../../../context/AuthProvider/useAuth";

function ReportBingoPerformance() {
    const  affiliation  = useAuth().response?.affiliation
  return (
    <RangeDatePickerAndActionsLayout
      actions={[
        ActionButtonEnum.SAVE_PDF, 
      ]}
      onRefresh={(startDateRage, endDateRange, output) =>
        getBingoPerformanceReport({
          dateIntervalStart: startDateRage.format(DateFormatEnum.YEAR_MONTH_DAY),
          dateIntervalEnd: endDateRange.format(DateFormatEnum.YEAR_MONTH_DAY),
          output,
        })
      }
      maxDays={affiliation==="manufacturer" || affiliation==="investigator"?365: 31}
    />
  )
}

export default ReportBingoPerformance
